<div class="header-group icon-left icon-m ui-icon-config">
    <h2>{{msg 'behavior'}}</h2>
</div>
<div class="inlineGroup fields">
    <div class="list-field col-sm-12 col-size-xs-12">
        <label class="annotation inlineGroup">{{msg 'chargeLevelDescription'}} : </label>
    </div>
    <field-select name="min"
                  class="l60-f40"
                  label-key="minPercent"
                  options="chargeLevelOptions"
                  option-none="false"
                  options-sort="false"
                  col="12 12"
                  required="true"></field-select>

    <field-switch name="alertOnStart" class="l60-f40" label-key="alertNotification" col="12 12"></field-switch>
    <div class="list-field col-sm-12 col-size-xs-12">
        <label class="annotation inlineGroup">{{msg 'chargeLevelAlertOnStartDescription'}}</label>
    </div>
    <field-switch name="alertOnEnd" class="l60-f40" label-key="alertTermination" col="12 12"></field-switch>
    <div class="list-field col-sm-12 col-size-xs-12">
        <label class="annotation inlineGroup">{{msg 'chargeLevelAlertOnEndDescription'}}</label>
    </div>
    <div class="list-field col-sm-12 col-size-xs-12">
        <label class="bold-annotation inlineGroup">{{msg 'chargeLevelNote'}}</label>
    </div>
</div>